/**
 * Checks if the coach has the necessary permissions to access a specific organization section.
 * If the coach does not have the required permissions, it redirects to a specified URL.
 *
 * @param {Object} ctx - The context object.
 * @param {Function} next - The next function to be called.
 * @param {string[]} permissions - The array of permissions required to access the section.
 * @param {string} redirection - The URL to redirect to if the coach does not have the required permissions.
 * @param {string[]} roles - The array of roles to check against the current organization coach role name.
 * @returns {void}
 */

export const checkOrganizationSectionPermission = (
  ctx,
  next,
  permissions = [],
  redirection = "/coaching-portal/athletes",
  roles
) => {
  try {
    const { locals, res } = ctx;
    const { activeUser, organizationRoleName } = locals;
    if (activeUser.organizationId) {
      const coachOrganizationPermissions =
        locals?.activeUser?.organizationPermissions || [];

      if (permissions !== "settings") {
        // First look for the permissions that allow the coach to acces to the section we are -
        // - in the ORGANIZATION permissions
        // These are by the permissions array e.g.: ["Templates", "PUSH"]
        const organizationSectionPermissions =
          locals?.organizationPermissions?.filter(({ permission }) =>
            permissions.includes(permission)
          ) || {};

        // Then, in the permisisons of the COACH, find the a permissions that matches with the ones that
        // allow the coach to access to the section
        if (
          locals?.activeUser?.organizationUserStatus &&
          !organizationSectionPermissions.some((desiredSectionPermission) =>
            coachOrganizationPermissions.includes(desiredSectionPermission._id)
          )
        ) {
          return res.redirect(redirection);
          //     return redirection ? res.redirect(redirection) : history.back();
        }
      }

      if (roles && !roles.includes(organizationRoleName)) {
        return res.redirect(redirection);
      }
    }

    return next();
  } catch (error) {
    console.log(
      "There was an error redirecting the coach: ",
      JSON.stringify(error, null, 4)
    );
  }
};
